import React, { useState } from 'react';
import Helmet from 'react-helmet';
import ReactDOM from 'react-dom';
import { Inertia } from '@inertiajs/inertia';
import { InertiaLink, usePage } from '@inertiajs/inertia-react';
import UserLayout from '../../../Shared/UserLayout';
import ProfileCard from '../../../Shared/ProfileCard';
import DataCard from '../../../Shared/DataCard';
import DataContainer from '../../../Shared/DataContainer';
import Icon from '../../../Shared/Icon';
import classNames from 'classnames';
import TextInput from '../../../Shared/TextInput';
import FileInput from '../../../Shared/FileInput';
import SelectInput from '../../../Shared/SelectInput';
import TextArea from '../../../Shared/TextArea';
import LoadingButton from '../../../Shared/LoadingButton';

function Show() {
     const { auth, errors, data } = usePage().props;
     const [sending, setSending] = useState(false);
     const [values, setValues] = useState({
          code: ''
     });

     const iconClasses = classNames('w-4 h-4 mr-2', {
          'text-white fill-current': false,
          'text-gray-500 hover:text-white fill-current': true
     });

     function handleChange(e) {
          const key = e.target.name;
          const value = e.target.value;
          setValues(values => ({
               ...values,
               [key]: value
          }));
     }

     function handleSubmit(e) {
          e.preventDefault();
          setSending(true);
          Inertia.post(route('student.post.content', data.id), values).then(() => {
               setSending(false);
          });
     }

     return (
          <React.Fragment key="permission-c">
               <Helmet>
                    <title>Student Content</title>
               </Helmet>
               <ProfileCard>
                    <div className="md:col-span-1">
                         <div className="px-4 sm:px-0">
                              <h3 className="text-lg font-small text-gray-600">Add Content Student</h3>
                              <h3 className="text-lg font-medium text-gray-900">{data.name}</h3>
                              <div className="hidden sm:block">
                                   <div className="py-8">
                                        <div className="border-t border-gray-400"></div>
                                   </div>
                              </div>
                              <div className="w-full mt-3">
                                   {!data.avatar && (<img src={`https://ui-avatars.com/api/?name=${data.name}&amp;color=7F9CF5&amp;background=EBF4FF`} className="mx-auto rounded-full h-20 w-20" />)}
                                   {data.avatar && (<img src={`${data.avatar}`} className="mx-auto rounded-full h-20 w-20" />)}
                              </div>
                              <p className="w-full font-small text-gray-600">First Name : <span className="font-bold float-right">{data.first_name}</span></p>
                              <p className="w-full font-small text-gray-600">Last Name : <span className="font-bold float-right">{data.last_name}</span></p>
                              <p className="w-full font-small text-gray-600">Username : <span className="font-bold float-right">{data.username} {data.price}</span></p>
                              <p className="w-full font-small text-gray-600">E-mail : <span className="font-bold float-right">{data.email}</span></p>
                              <p className="w-full font-small text-gray-600">Sex : <span className="font-bold float-right">{data.sex}</span></p>
                         </div>
                    </div>
                    <DataCard>
                         <form onSubmit={handleSubmit}>
                              <div className="px-4 py-5 sm:p-6">
                                   <div className="grid grid-cols-3 gap-3">
                                        <div className="col-span-12 text-right">
                                             <InertiaLink href={route('student.edit', data.id)} className="float-left border border-blue-500 text-sm text-blue-500 p-2 rounded focus:outline-none hover:bg-blue-600 hover:text-blue-100 inline-flex items-center">
                                                  <Icon name="eye" className={iconClasses} />
                                                  Edit
                                             </InertiaLink>
                                             <InertiaLink href={route('student.index')} className="bg-transparent border border-gray-500 text-sm text-gray-500 p-2 rounded focus:outline-none hover:bg-gray-600 hover:text-gray-100 inline-flex items-center">
                                                  <Icon name="back" className={iconClasses} />
                                                  Back
                                             </InertiaLink>
                                        </div>
                                        <div className="col-span-6 sm:col-span-4">
                                             <TextInput
                                                  className="form-input rounded-md shadow-sm mt-4 block w-full"
                                                  label="Add Retel Code"
                                                  name="code"
                                                  type="text"
                                                  disable={false}
                                                  readonly={false}
                                                  errors={errors.code}
                                                  value={values.code}
                                                  onChange={handleChange}
                                             />
                                             <div className="flex items-center justify-end py-3 text-right rounded-b">
                                                  <LoadingButton type="submit" loading={sending} className="inline-flex items-center px-4 py-2 bg-gray-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:shadow-outline-gray disabled:opacity-25 transition ease-in-out duration-150 ml-4">
                                                       Assign
                                                  </LoadingButton>
                                             </div>
                                        </div>
                                   </div>
                              </div>
                         </form>
                    </DataCard>
               </ProfileCard>
          </React.Fragment>
     );
}

// Persisten layout
// Docs: https://inertiajs.com/pages#persistent-layouts
Show.layout = page => <UserLayout children={page} header={'Student Content'} />;

export default Show;
